"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var utils_1 = require("../utils");
var GridProvider_1 = require("./GridProvider");
exports.GridToggleableContext = react_1.createContext({
    hiddenColumns: [],
    visibleColumns: [],
    setHiddenColumns: function () { },
    onColumnToggle: function () { },
    rowWidth: 0
});
exports.useGridToggleableContext = function () { return react_1.useContext(exports.GridToggleableContext); };
var GridToggleable = /** @class */ (function (_super) {
    __extends(GridToggleable, _super);
    function GridToggleable(props, context) {
        var _this = _super.call(this, props) || this;
        var columns = context.state.columns;
        _this.state = {
            hiddenColumns: columns.filter(function (col) { return col.props.hidden; }).map(function (col) { return col.key; })
        };
        _this.setHiddenColumns = _this.setHiddenColumns.bind(_this);
        return _this;
    }
    GridToggleable.prototype.setHiddenColumns = function (hiddenColumns) {
        this.setState({ hiddenColumns: hiddenColumns });
    };
    GridToggleable.prototype.render = function () {
        var _this = this;
        var _a = this.props, children = _a.children, onColumnToggle = _a.onColumnToggle;
        var hiddenColumns = this.state.hiddenColumns;
        var _b = this.context.state, columns = _b.columns, scrollbarWidth = _b.scrollbarWidth, hasVerticalScroll = _b.hasVerticalScroll, columnsWidth = _b.columnsWidth, layoutWidth = _b.layoutWidth;
        var visibleColumns = columns.filter(function (_a) {
            var key = _a.key;
            return !hiddenColumns.includes(key);
        });
        var rowWidth = utils_1.computeRowWidth({
            visibleColumns: visibleColumns,
            columnsWidth: columnsWidth,
            hasVerticalScroll: hasVerticalScroll,
            layoutWidth: layoutWidth,
            scrollbarWidth: scrollbarWidth
        });
        return (react_1.default.createElement(exports.GridToggleableContext.Provider, { value: {
                hiddenColumns: hiddenColumns,
                visibleColumns: visibleColumns,
                setHiddenColumns: function (hiddenColumns) {
                    _this.setHiddenColumns(hiddenColumns);
                },
                onColumnToggle: function (currentColumn) {
                    onColumnToggle === null || onColumnToggle === void 0 ? void 0 : onColumnToggle(currentColumn);
                },
                rowWidth: rowWidth
            } }, children));
    };
    return GridToggleable;
}(react_1.default.Component));
GridToggleable.contextType = GridProvider_1.GridContext;
exports.default = GridToggleable;
//# sourceMappingURL=GridToggleable.js.map